module.exports = __webpack_public_path__ + "1_0_62/img/tasks_body.1e2e213d.jpg";